module.exports = __webpack_public_path__ + "img/autofolia.953677bf.jpg";